import { render, staticRenderFns } from "./LxrInfo.vue?vue&type=template&id=d4af210a&scoped=true&"
import script from "./LxrInfo.vue?vue&type=script&lang=js&"
export * from "./LxrInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4af210a",
  null
  
)

export default component.exports